import React from 'react';

import PropTypes from 'prop-types';
import { Table, Select } from 'semantic-ui-react';

import { multiCaseGet } from 'libs/format';

import { GoogleLocationPropType } from '../../../AccountSettings/AccountSettings.types';
import { GoogleLocationMapShape } from '../../AccountLocationList.types';
import LocationDetails from '../LocationDetails';
import LocationStatus from '../LocationStatus/LocationStatus';

const propTypes = {
  gmbLocation: GoogleLocationPropType.isRequired,
  gmbLocationMap: GoogleLocationMapShape.isRequired,
  onFishermanLocationSelect: PropTypes.func.isRequired,
  getSelectableLocations: PropTypes.func.isRequired,
};

function LocationRow({
  gmbLocation,
  gmbLocationMap,
  onFishermanLocationSelect,
  getSelectableLocations,
}) {
  const gmbLocationId = multiCaseGet(gmbLocation, 'locationId');

  return (
    <Table.Row key={gmbLocationId}>
      <LocationDetails gmbLocation={gmbLocation} />
      <LocationStatus gmbLocation={gmbLocation} />
      <Table.Cell>
        <Select
          placeholder="Select a location"
          value={gmbLocationMap[gmbLocationId]}
          onChange={(e, { value }) => onFishermanLocationSelect(gmbLocationId, value)}
          options={getSelectableLocations(gmbLocation)}
          disabled={false}
          fluid={false}
        />
      </Table.Cell>
    </Table.Row>
  );
}

LocationRow.propTypes = propTypes;

export default LocationRow;
